import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes'
import { PageTitle } from '@src/api/common/PageTitleType'

const Breadcrumbs: Array<BreadcrumbItem> = [
    {
        title: 'Admin',
        isLink: false
    },
    { title: 'Theme', isLink: false },
]

const Title: PageTitle = {
    title: 'Theme',
}

export { Breadcrumbs, Title };